// Injected via react-to-print pageStyle — @page margin boxes are required for
// counter(page) / counter(pages); DOM ::after counters render as "Page 0 of 0".
export const RECEIPT_PRINT_PAGE_STYLE = `@media print {
  @page {
    size: letter;
    margin: 0.45in 0.4in 0.65in 0.4in;

    @bottom-center {
      content: 'Page ' counter(page) ' of ' counter(pages);
      font-size: 11pt;
      font-family: Roboto, sans-serif;
    }
  }
}`
